<style type="text/css">
  div.full-bg-cover {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 1;
  transform: translateX(-50%) translateY(-50%);
  background: linear-gradient(47deg, #1f1f24, rgba(0, 0, 0, 0.5) 65%, rgba(0, 0, 0, 0)), url('/assets/img/main_game/main-game-finsihed-bg.jpg') no-repeat;
  background-size: cover;
  transition: background 300ms ease-in 200ms;
}
div.text-center {
text-align: left!important;
left: 14%;
z-index: 2;
position: absolute;
/* left: 50%; */
width: 30%;
top: 50%;
transform: translate(0%, -50%);
max-width: 517px;
min-width: 517px;
}
div.text-center h1{
}
div.text-center p{
margin: 20px 0 40px 0;
}
div.text-center button.active{
margin-right: 16px;
}
</style>
<div class="full-bg-cover"></div>
<div class="text-center">
  <h1>{{finishedTitle}}</h1>
  <p>{{finishedText}}</p>
  @if (showFinishedButton) {
    <button id='finishedD' (click)="onAfterDistractionEnd()" class="btn btn-outline-primary btn-outline hover active">Start</button>
  }
</div>
